import MarkdownContentRenderer from 'fitify-ui-landing/src/components/Markdown/MarkdownContentRenderer'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { StyledLegalDocumentContainer } from '@/components/blocks/Document/LegalDocument.Styled'
import Layout from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

import content from '../../public/assets/markdown/terms.md'

const TermsPage: NextPage = () => {
  const { t } = useTranslation()

  return (
    <Layout
      seo={{
        title: t('landing_terms_of_service') + ' | Fitify',
        description: t('landing_terms_of_service_meta_description'),
      }}
    >
      <MarkdownContentRenderer
        content={content}
        contentWrapper={StyledLegalDocumentContainer}
      />
    </Layout>
  )
}

export default TermsPage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
